import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaLinkedin } from 'react-icons/fa';
import LeadMagnetBar from './LeadMagnetBar';
import { trackEvent } from '../utils/analytics';
import { CTA_PRIMARY_PATH, CTA_SECONDARY_PATH } from '../constants/cta';
import { useI18n } from '../i18n/I18nContext';

const Footer = () => {
  const { t } = useI18n();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <LeadMagnetBar />
      <section className="footer-conversion-banner" aria-label="Call to action">
        <div className="container footer-conversion-inner">
          <div>
            <h3 className="footer-conversion-title">{t('footer.conversionTitle')}</h3>
            <p className="footer-conversion-text">{t('footer.conversionText')}</p>
          </div>
          <div className="footer-conversion-actions">
            <Link
              to={CTA_PRIMARY_PATH}
              className="btn btn-primary"
              onClick={() => trackEvent('footer_cta_click', { cta: 'book_consultation' })}
            >
              {t('nav.bookConsultation')}
            </Link>
            <Link
              to={CTA_SECONDARY_PATH}
              className="btn btn-secondary"
              onClick={() => trackEvent('footer_cta_click', { cta: 'view_services' })}
            >
              {t('nav.viewServicesSecondary')}
            </Link>
          </div>
        </div>
      </section>

      <div className="container">
        <p className="footer-trust-line">
          <strong>{t('footer.registeredBadge')}</strong>
          {' — '}
          {t('footer.brandTagline')}
        </p>
        <p className="footer-trust-line footer-trust-line-secondary">{t('footer.trustLineSuffix')}</p>

        <div className="footer-content footer-content-premium">
          <div className="footer-section footer-brand-block">
            <h3>{t('footer.brandTitle')}</h3>
            <p>{t('footer.brandBody')}</p>
          </div>

          <div className="footer-section">
            <h3>{t('footer.companyCol')}</h3>
            <ul>
              <li>
                <Link to="/about">{t('nav.companyAboutTitle')}</Link>
              </li>
              <li>
                <Link to="/team">{t('nav.companyTeamTitle')}</Link>
              </li>
              <li>
                <Link to="/blog">{t('nav.companyBlogTitle')}</Link>
              </li>
              <li>
                <Link to="/case-studies">{t('footer.caseStudies')}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>{t('footer.servicesCol')}</h3>
            <ul>
              <li>
                <Link to="/services">{t('nav.services')}</Link>
              </li>
              <li>
                <Link to="/products">{t('nav.products')}</Link>
              </li>
              <li>
                <Link to="/portfolio">{t('nav.portfolio')}</Link>
              </li>
              <li>
                <Link to="/solutions/web-development">Web</Link>
              </li>
              <li>
                <Link to="/solutions/mobile-development">Mobile</Link>
              </li>
              <li>
                <Link to="/solutions/ai-solutions">AI</Link>
              </li>
              <li>
                <Link to="/solutions/data-engineering">Data</Link>
              </li>
              <li>
                <Link to="/solutions/digital-marketing">Growth</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section footer-contact-block">
            <h3>{t('footer.contactCol')}</h3>
            <p className="footer-whatsapp-cta">{t('footer.whatsappCta')}</p>
            <div className="contact-item">
              <FaPhone className="contact-icon" aria-hidden />
              <a href="tel:+923419843763">+92 341 9843763</a>
            </div>
            <div className="contact-item">
              <FaWhatsapp className="contact-icon" aria-hidden />
              <a href="https://wa.me/923419843763" target="_blank" rel="noopener noreferrer">
                WhatsApp
              </a>
            </div>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" aria-hidden />
              <a href="mailto:info@msatechnologies.com">info@msatechnologies.com</a>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" aria-hidden />
              <span>{t('footer.remoteLine')}</span>
            </div>
            <div className="social-links">
              <a
                href="https://www.facebook.com/share/1TvzjczHHL/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('social_click', { channel: 'facebook', location: 'footer' })}
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.linkedin.com/company/msa-tech-solutions/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('social_click', { channel: 'linkedin', location: 'footer' })}
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://instagram.com/MSATechnologies"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('social_click', { channel: 'instagram', location: 'footer' })}
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://wa.me/923419843763"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('social_click', { channel: 'whatsapp', location: 'footer' })}
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} MSA Technologies. {t('footer.registeredBadge')}
          </p>
          <div className="footer-legal-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/security">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
